<tax-page-header
  [titleText]="isNewGroup ? ('group.title.add' | translate) : group?.title"
  [dropdownItems]="dropdownItems"
></tax-page-header>

<form (ngSubmit)="sendGroup()" class="ui-kit-content-container--with-separators">
  <tax-input
    [layoutColumns]="2"
    labelText="group.name"
    data-qa-input="group-name"
    [tabindex]="0"
    [formControl]="groupTitle"
    name="groupTitle"
    [minlength]="1"
    [maxlength]="255"
    placeholder="group.name.placeholder"
    [autofocus]="true"
    [clearable]="true"
  ></tax-input>

  <tax-access-settings-block
    title="group.account"
    placeholder="group.account.description"
    [items]="displayedSelectedModules"
    [isNeedTranslate]="true"
    (openModal)="openPermissionsModal()"
  ></tax-access-settings-block>

  <!--TODO: fix $any-->
  <tax-access-settings-block
    title="group.retail.place"
    placeholder="group.retail.place.description"
    [items]="$any(retailPlaces | selected)"
    iterableProperty="title"
    (openModal)="openRetailPlacesModal()"
  ></tax-access-settings-block>

  <!--TODO: fix $any-->
  <tax-access-settings-block
    title="group.users"
    placeholder="group.users.description"
    [items]="$any(users | selected)"
    (openModal)="openUsersModal()"
    [itemTemplate]="itemTemplate"
  >
    <ng-template #itemTemplate let-item>
      {{ $any(item)['name'] || $any(item)['login'] }}
    </ng-template>
  </tax-access-settings-block>

  <div class="ui-kit-bottom-buttons-block">
    <button data-qa-button="go-back" class="back-button" (click)="back()" type="button" translate>
      group.back
    </button>
    <button data-qa-button="save-group" class="button_blue" [disabled]="groupTitle.invalid">
      {{ (isNewGroup ? 'button.add' : 'button.save') | translate }}
    </button>
  </div>
</form>
